import * as React from "react";

interface SectionSubHeadingProps {
  children: React.ReactNode;
}

export const SectionSubHeading = ({ children }: SectionSubHeadingProps): JSX.Element => {
  return <h3 className="!tw-font-CircularXXSub !tw-text-[20px] !tw-font-normal !tw-text-grey_800">{children}</h3>;
};
